import { t } from '@/i18n';
import { containHalfWidthString } from '@/utils';
import type { UseFormSetError } from 'react-hook-form';
import type { z } from 'zod';
import type { PaymentFormSchema } from '../projects/_models/payment';

type FormValues = z.infer<typeof PaymentFormSchema>;

export const validateInputPayment = (
  { name, isOthers, corporateNumber }: FormValues,
  setError: UseFormSetError<FormValues>,
) => {
  let hasError = false;

  if (containHalfWidthString(name)) {
    setError('name', {
      message: t('validation.disallow-half-width-characters-in-payment-name'),
    });
    hasError = true;
  }

  if (!isOthers) {
    if (!corporateNumber) {
      setError('corporateNumber', {
        message: t('validation.required'),
      });
      hasError = true;
    }
    if (corporateNumber && corporateNumber.toString().length !== 13) {
      setError('corporateNumber', {
        message: t('validation.string-extract', { length: 13 }),
      });
      hasError = true;
    }
  }

  return { hasError };
};
